import React from 'react';
import PropTypes from 'prop-types';

const MoreIcon = ({ isSelected }) => {
  if (isSelected) {
    return (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <circle cx="3.125" cy="12" r="3" fill="#006FCF" />
        <circle cx="12.125" cy="12" r="3" fill="#006FCF" />
        <circle cx="21.125" cy="12" r="3" fill="#006FCF" />
      </svg>

    );
  }

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <circle cx="3.125" cy="12" r="2.25" stroke="#00175A" strokeWidth="1.5" />
      <circle cx="12.125" cy="12" r="2.25" stroke="#00175A" strokeWidth="1.5" />
      <circle cx="21.125" cy="12" r="2.25" stroke="#00175A" strokeWidth="1.5" />
    </svg>

  );
};

MoreIcon.propTypes = {
  isSelected: PropTypes.bool,
};

export default MoreIcon;
